module.exports = __webpack_public_path__ + "72b8b64032a68b24bcd740fb7c125902.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Light.woff
// module id = 393
// module chunks = 0